import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Formulario from 'components/public/Formulario/Formulario';
import { datosRegistroEspectaculo } from 'utils/formData';
import { IFile, IFormulario, ISelectOptions } from 'utils/models/interfaces';
import { registroEspectaculo } from 'services/servicioPost';
import { IRequestEspectaculo } from 'utils/models/types';
import { useError } from 'services/ErrorContext';
import { EventAvailableOutlined } from '@mui/icons-material';
import { fetchTiposElenco } from 'utils/redux/features/tiposElencoSlice';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import Spinner from 'components/public/Spinner/Spinner';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import NoResponse from 'pages/auxiliares/NoResponse';
import { crearOpcionesTipos } from 'utils/utilities';
import { fetchGeneros } from 'utils/redux/features/generosSlice';
import { anchoMaxLogueado } from 'utils/constants';

const AltaEspectaculo = () => {
  const { tiposElenco, loadingTiposElenco, errorTiposElenco } = useSelector((state: RootState) => state.tiposElenco);
  const { generos, loadingGeneros, errorGeneros } = useSelector((state: RootState) => state.generos);
  const { error, setError, clearError, loading, setLoading } = useError();
  const dispatch = useDispatch<AppDispatch>();
  const opcionesTipoElenco: ISelectOptions[] = crearOpcionesTipos(tiposElenco, 'TipoElenco');
  const opcionesGenero: ISelectOptions[] = crearOpcionesTipos(generos, 'Genero');
  const [fotos, setFotos] = useState<FileList>();

  useEffect(() => {
    dispatch(fetchTiposElenco());
    dispatch(fetchGeneros());
  }, [dispatch]);

  const [mensajeExito, setMensajeExito] = useState('');

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFotos(event.target.files);
    }
  };

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError();

    const formData = new FormData();
    // Agregamos todos los campos al FormData
    formData.append('Id', '0');
    formData.append('Nombre', data.Nombre);
    formData.append('VisibleEnGrilla', String(data.VisibleEnGrilla || false));
    formData.append('AforoDisponible', String(data.AforoDisponible));
    formData.append('TipoElencoId', String(data.TipoElenco || 0));
    formData.append('PorcentajeAgadu', String(data.PorcentajeAgadu));
    formData.append('PorcentajeCofonte', String(data.PorcentajeCofonte));
    formData.append('BannerDestacado', String(data.BannerDestacado));
    formData.append('SalaId', '1');
    formData.append('Autor', data.Autor);
    formData.append('Elenco', data.Elenco);
    formData.append('Director', data.Director);
    formData.append('GeneroId', String(data.Genero));
    formData.append('Precio', String(data.Precio));
    formData.append('Descripcion', data.Descripcion);
    formData.append('AsistenteDireccion', data.AsistenteDireccion || '');
    formData.append('Vestuarista', data.Vestuarista || '');
    formData.append('Iluminador', data.Iluminador || '');
    formData.append('Sonidista', data.Sonidista || '');
    formData.append('Musica', data.Musica || '');
    formData.append('DisenoGrafico', data.DisenoGrafico || '');
    formData.append('Traduccion', data.Traduccion || '');
    formData.append('Escenografia', data.Escenografia || '');
    formData.append('Fotografia', data.Fotografia || '');

    // @ts-expect-error -- form field typed by react-hook-form, not in interface
    const afiche: IFile = data?.Afiche[0];
    // @ts-expect-error -- form field typed by react-hook-form, not in interface
    const banner: IFile = data?.Banner[0];

    if (afiche) {
      formData.append('Afiche', afiche);
    }

    if (banner) {
      formData.append('Banner', banner);
    }

    if (fotos) {
      Array.from(fotos).forEach((file, index) => {
        formData.append(`Fotos`, file);
      });
    }

    const requestEspectaculo: IRequestEspectaculo = {
      Id: 0,
      Nombre: data.Nombre,
      VisibleEnGrilla: data.VisibleEnGrilla || false,
      AforoDisponible: data.AforoDisponible,
      // @ts-expect-error -- form field typed by react-hook-form, not in interface
      TipoElencoId: data.TipoElenco || 0,
      PorcentajeAgadu: data.PorcentajeAgadu,
      PorcentajeCofonte: data.PorcentajeCofonte,
      Afiche: afiche || '',
      Banner: banner || '',
      BannerDestacado: data.BannerDestacado,
      SalaId: 1,
      Fotos: null, // Las fotos se mandan mediante FormData
      Autor: data.Autor,
      Elenco: data.Elenco,
      Director: data.Director,
      // @ts-expect-error -- form field typed by react-hook-form, not in interface
      GeneroId: data.Genero,
      Precio: data.Precio,
      Descripcion: data.Descripcion,
      AsistenteDireccion: data.AsistenteDireccion || '',
      Vestuarista: data.Vestuarista || '',
      Iluminador: data.Iluminador || '',
      Sonidista: data.Sonidista || '',
      Musica: data.Musica || '',
      DisenoGrafico: data.DisenoGrafico || '',
      Traduccion: data.Traduccion || '',
      Escenografia: data.Escenografia || '',
      Fotografia: data.Fotografia || '',
    };

    // Para no perder los datos si expira la sesión en el medio del llenado
    localStorage.setItem('espectaculoPendiente', JSON.stringify(requestEspectaculo));

    try {
      // Formdata = true para que envíe con headers de tipo form-data
      await registroEspectaculo(requestEspectaculo, setError, setLoading, true, formData);
      setMensajeExito('¡Espectáculo registrado con éxito! Podrás agregar funciones desde el listado de espectáculos.');
      localStorage.removeItem('espectaculoPendiente');
    } catch (error) {
      console.error('Error de registro:', error);
    }
  }

  const handleVolver = () => {
    setMensajeExito('');
  };

  const error401 = errorTiposElenco?.includes('permisos');

  return (
    <Box maxWidth={anchoMaxLogueado} mx="auto">
      {loadingTiposElenco || loadingGeneros ? (
        <Spinner />
      ) : errorTiposElenco || errorGeneros ? (
        error401 ? (
          <NotAllowed />
        ) : (
          <NoResponse />
        )
      ) : (
        <Formulario
          campos={datosRegistroEspectaculo}
          titulo="Nuevo espectáculo"
          textoBoton="Registrar"
          onSubmit={handleSubmit}
          datos={opcionesTipoElenco.concat(opcionesGenero)}
          onVolver={handleVolver}
          mensajeExito={mensajeExito}
          mensajeError={error}
          loading={loading}
          iconoBoton={EventAvailableOutlined}
          handleFileUpload={handleFileUpload}
        />
      )}
    </Box>
  );
};

export default AltaEspectaculo;
